import { Component, OnInit, Input, OnChanges, SimpleChanges, NgZone, OnDestroy } from '@angular/core';
import { GoogleChartService } from '../services/google-chart.service';
import { Router, ActivatedRoute, RouterEvent, NavigationEnd } from '@angular/router';
import { rtohrlyLoadsTbl, PeakShavingTimes } from '../Models/LoadsData';
import { DatePipe } from '@angular/common';
import { MinMaxDate } from '../Models/MiscModels';
import { RtoHrlyDemandService } from '../services/rto-hrly-demand.service';
import { SignalrISOdataService } from '../services/signalr-ISOdata.service';
import { MiscService } from '../services/misc.service';
import { NONE_TYPE } from '@angular/compiler/src/output/output_ast';
import { ResizedEvent } from 'angular-resize-event';
import { filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ShaveTimesService } from '../services/shave-times.service';

@Component({
  selector: 'app-rto-hrly-load-chart',
  templateUrl: './rto-hrly-load-chart.component.html',
  styleUrls: ['./rto-hrly-load-chart.component.css']
})
export class RtoHrlyLoadChartComponent implements OnInit, OnDestroy {
  public destroyed = new Subject<any>();
  private gLib: any;
  private minMaxDate: MinMaxDate;

  private rtoHrlyLoadDashboard: any;

  private rtoHrlyLoadLine: any;
  private rtoHrlyLoadDateSlider: any;
  public btnLabel = 'Show as Table';
  private rtoHrlyLoadTable;
  private chartTitle: string;

  constructor(private gChartService: GoogleChartService, private route: ActivatedRoute,
    private signalrService: SignalrISOdataService, private _ngZone: NgZone, private miscSvc: MiscService,
    private ShaveTimesSvc: ShaveTimesService) {

  }

  private getOptions(chartType) {
    let options;

    switch (chartType) {

      case 'ComboChart':
        options = {
          enableInteractivity: true,
          interpolateNulls: 'true',
          series: {

            0: {
              type: 'bars', color: '#c8393c',
              targetAxisIndex: 1, lineWidth: 2, interpolateNulls: 'true', opacity: 0.01
            },
            1: { type: 'bars', color: 'black', targetAxisIndex: 0 }
            , 2: { type: 'line', targetAxisIndex: 1, color: '#13f9f6', lineWidth: 6, interpolateNulls: 'true' }
            , 3: { type: 'steppedArea', targetAxisIndex: 0, color: '#c0c0c0', lineWidth: 2, interpolateNulls: 'true', opacity: 0.01 }
            , 4: { type: 'steppedArea', targetAxisIndex: 0, color: 'orange', lineWidth: 3, interpolateNulls: 'true', opacity: 0.04 }
            // , 5: { type: 'bar', targetAxisIndex: 0, color: '#087037', pointShape: 'star',
            // pointSize: 18, lineWidth: 3, interpolateNulls: 'false', opacity: 0.04 }
            // , 6: { type: 'bar', targetAxisIndex: 0, color: 'red', pointShape: 'star', pointSize: 18, 
            //     lineWidth: 3, interpolateNulls: 'false', opacity: 0.04 }

            , 5: {
              type: 'steppedArea', targetAxisIndex: 0, color: 'green',
              interpolateNulls: 'false', opacity: 0.04
            }
            , 6: {
              type: 'steppedArea', targetAxisIndex: 0, color: 'red', 
               interpolateNulls: 'false', opacity: 0.04
            }

          },


          colors: ['#13f9f6'],
          legend: {
            position: 'top', alignment: 'end', textStyle: { fontSize: 14 },
          },
          titleTextStyle: {
            color: 'black',    // any HTML string color ('red', '#cc00cc')
            fontName: 'Montesserat', // i.e. 'Times New Roman'
            fontSize: '22', // 12, 18 whatever you want (don't specify px)
            bold: false,    // true or false
            italic: true,   // true of false
          },
          chartArea: { width: '80%', height: '80%' },
          crosshair: { trigger: 'both' },
          curveType: 'none',

          vAxes: [
            {
              title: 'Consumption Load', textStyle: { fontSize: '12' },
              format: '#,### KW',
              minValue: 0, maxValue: 50, gridlines: { count: 0 }
            },
            {
              title: 'PJM RTO Load', textStyle: { fontSize: '12' },
              format: '#,### MW',
              // minValue: 2000, maxValue: 180000, gridlines: { count: 8 }
            }
          ],
          hAxis: {
            textStyle: {
              fontSize: '12'
            },
            gridlines: {
              count: -1,
              units: {
                days: { format: ['MMM dd'] },
                hours: { format: ['HH:mm', 'ha'] },
              }
            },
            minorGridlines: {
              units: {
                hours: { format: ['hh:mm:ss a', 'ha'] },
                minutes: { format: ['HH:mm a Z', ':mm'] }
              }
            },

          },
        };

        break;

      case 'Table':
        options = {
          showRowNumber: true,
          width: '80%',
          height: '80%'
        };
        break;

      default:
        options = {};
    }

    return options;
  }

  getFilterOptions() {
    const controlOptions = {
      // Filter by the date axis.
      'filterColumnIndex': 0,
      ui: {
        'chartOptions': {
          colors: ['grey'],
          chartArea: { width: '80%', height: '100%' },
          hAxis: {
            textStyle: {
              fontSize: '14'
            },
            gridlines: {
              count: -1,
              units: {
                days: { format: ['MMM dd'] },
                hours: { format: ['HH:mm', 'ha'] },
              }
            },
            minorGridlines: {
              units: {
                hours: { format: ['hh:mm:ss a', 'ha'] },
                minutes: { format: ['HH:mm a Z', ':mm'] }
              }
            }
          }
        },
      }
    };
    return controlOptions;
  }

  ngOnInit() {

    this.gLib = this.gChartService.getGoogle();
    this.gLib.charts.load('current', { 'packages': ['corechart', 'table', 'controls'] });
    this.gLib.charts.setOnLoadCallback(this.drawRtoLoadChart.bind(this));
    this.rtoHrlyLoadTable = new this.gLib.visualization.DataTable();

    this.signalrService.RtoHrlyLoadsRefreshMessageReceived
      .pipe(takeUntil(this.destroyed))
      .subscribe((data) => {
        this._ngZone.run(() => {
          this.updateChartDataTable(data);

        });
      });

  }
  formatAxes() {
    const date_formatter = new this.gLib.visualization.DateFormat({ pattern: 'MMM dd, yyyy,  h:mm aa' });
    date_formatter.format(this.rtoHrlyLoadTable, 0);  // Where 0 is the index of the column

    const y1formatter = new this.gLib.visualization.NumberFormat({ suffix: ' KW', pattern: '#,###' });
    y1formatter.format(this.rtoHrlyLoadTable, 2); // Apply formatter to second column

    const y2formatter = new this.gLib.visualization.NumberFormat({ suffix: ' MW', pattern: '#,###' });
    y2formatter.format(this.rtoHrlyLoadTable, 1); // Apply formatter to second column

    y2formatter.format(this.rtoHrlyLoadTable, 3); // Apply formatter to second column
  }

  private createChartDataTable(data: Array<rtohrlyLoadsTbl>, ShaveData) {

    this.rtoHrlyLoadTable.addColumn('date', 'Date');
    this.rtoHrlyLoadTable.addColumn('number', 'PJM RTO Load');
    this.rtoHrlyLoadTable.addColumn('number', 'Consumption Load');

    this.rtoHrlyLoadTable.addColumn('number', 'PJM RTO Forecast');

    this.rtoHrlyLoadTable.addColumn({ type: 'string', role: 'style' });

    this.rtoHrlyLoadTable.addColumn('number', 'Daily Peak');
    this.rtoHrlyLoadTable.addColumn({ type: 'string', role: 'tooltip' });

    this.rtoHrlyLoadTable.addColumn('number', 'Candidate 5 CPs');
    this.rtoHrlyLoadTable.addColumn({ type: 'string', role: 'tooltip' });

    this.rtoHrlyLoadTable.addColumn('number', 'CP Shaving on');
    this.rtoHrlyLoadTable.addColumn('number', 'CP Shaving Off');



    const date = new Date(data[0].timestamp);
    const evalTimeStr = date.toLocaleString() + ' (EST)';
    this.chartTitle = 'PJM RTO Load at hourly intervals. Last Reading at ' + evalTimeStr;

    data.splice(0, 1);
    this.addRowsChartDataTable(data);
    this.addCPShavingChartData(ShaveData);
  }

  private addRowsChartDataTable(data: Array<rtohrlyLoadsTbl>) {
    const chartRow = new Array<Date | number | string | boolean>();

    for (let i = 0; i < data.length; i++) {

      chartRow.length = 0;
      const date = new Date(data[i].timestamp);

      chartRow.push(date);

      chartRow.push(data[i].hrlyInstLoad
        / (data[i].rtoNumReads));

      chartRow.push(data[i].hrlyWatts
        / (data[i].meterNumReads * 1000));

      chartRow.push(data[i].hrlyForecstLoad
        / (data[i].forecstNumReads));

      chartRow.push('opacity:.5');

      const peak = data[i].peak;
      if ((peak !== 0 || peak != null) && (peak === 1)) {
        chartRow.push(50);
        chartRow.push('Local Peak:  Hour ending at ' + date.toString());
      } else {
        chartRow.push(0);
        chartRow.push('Not a Peak' + date.toString());
      }

      if ((peak !== 0 || peak != null) && (peak === 2)) {
        chartRow.push(50);
        chartRow.push('Candidate CP:  Hour ending at ' + date.toString());
      } else {
        chartRow.push(0);
        chartRow.push('');
      }
      chartRow.push(null);
      chartRow.push(null);

      this.rtoHrlyLoadTable.addRow(chartRow);


    }
    this.formatAxes();
  }
  private addCPShavingChartData(ShaveTimesData: Array<PeakShavingTimes>) {

    const chartRow = new Array<Date | number | string | boolean>();

    const numRows = this.rtoHrlyLoadTable.getNumberOfRows();

    this.rtoHrlyLoadTable.insertRows(numRows, 2 * ShaveTimesData.length);
    for (let i = 0; i < ShaveTimesData.length; i = i + 1) {

      this.rtoHrlyLoadTable.setCell(numRows + 2 * i, 0, new Date(ShaveTimesData[i].startShaveTime));
      this.rtoHrlyLoadTable.setCell(numRows + 2 * i, 9, 50);

      if (ShaveTimesData[i].endShaveTime != null) {
        this.rtoHrlyLoadTable.setCell(numRows + 2 * i + 1, 0, new Date(ShaveTimesData[i].endShaveTime));
        this.rtoHrlyLoadTable.setCell(numRows + 2 * i + 1, 10, 50);
      }

    }
    this.formatAxes();
  }

  private updateChartDataTable(data: Array<rtohrlyLoadsTbl>) {

    if (this.rtoHrlyLoadDashboard !== undefined) {
      const maxEvalAtStr = this.miscSvc.removeRowsHrlyLoad(this.rtoHrlyLoadTable, data);
      this.addRowsChartDataTable(data);
      this.updateRtoLoadChart(data, maxEvalAtStr);
    }
  }

  private createLoadChartWrapper() {   // Line chart visualization

    this.rtoHrlyLoadLine = new this.gLib.visualization.ChartWrapper({
      'chartType': 'ComboChart',
      'containerId': 'rtoHrlyLoadline_div',
    });
    const options = this.getOptions('ComboChart');
    this.rtoHrlyLoadLine.setOptions(options);
    this.rtoHrlyLoadLine.setOption('title', this.chartTitle);
  }
  private drawRtoLoadChart(options) {

    const ShaveData = this.route.snapshot.data.ShaveTimesData;
    this.createChartDataTable(this.route.snapshot.data.RtoHrlyLoadData, ShaveData);
    this.rtoHrlyLoadTable.sort([0]);

    // Create a dashboard.
    const dash_container = document.getElementById('rtoHrlyLoaddashboard_div');


    this.rtoHrlyLoadDashboard = new this.gLib.visualization.Dashboard(dash_container);

    const dtNumRows = this.rtoHrlyLoadTable.getNumberOfRows();

    const MaxDt = new Date(this.rtoHrlyLoadTable.getValue(dtNumRows - 1, 0));
    const MinDt = new Date(MaxDt);
    MinDt.setDate(MaxDt.getDate() - 5);
    if (MinDt == null)
      MinDt.setDate(MaxDt.getDate() - 6);
    // Create a date range slider
    this.rtoHrlyLoadDateSlider = new this.gLib.visualization.ControlWrapper({
      'controlType': 'ChartRangeFilter',
      'containerId': 'rtoHrlyLoadcontrol_div',

    });
    const state_obj = { 'range': { 'start': MinDt, 'end': MaxDt } };
    this.rtoHrlyLoadDateSlider.setState(state_obj);
    const controlOptions = this.getFilterOptions();
    this.rtoHrlyLoadDateSlider.setOptions(controlOptions);


    this.createLoadChartWrapper();


    // Bind rtoHrlyLoadLine to the dashboard, and to the controls
    // this will make sure our line chart is updated when our date changes
    this.rtoHrlyLoadDashboard.bind(this.rtoHrlyLoadDateSlider, this.rtoHrlyLoadLine);

    const chartType = this.rtoHrlyLoadLine.getChartType();
    if (chartType === 'Table') {
      const view = new this.gLib.visualization.DataView(this.rtoHrlyLoadTable);
      // view.hideColumns([4, 5]);
      this.rtoHrlyLoadDashboard.draw(view, { sortColumn: 0 });
    } else {
      this.rtoHrlyLoadDashboard.draw(this.rtoHrlyLoadTable);
    }
  }

  private updateRtoLoadChart(data: Array<rtohrlyLoadsTbl>, MaxEvalAtStr) {

    if (this.rtoHrlyLoadDashboard !== undefined) {

      this.chartTitle = this.chartTitle = 'PJM RTO Load at hourly intervals. Last Reading at ' + MaxEvalAtStr;
      this.rtoHrlyLoadLine.setOption('title', this.chartTitle);


      let state_obj = this.rtoHrlyLoadDateSlider.getState();
      const startDt = state_obj.range.start;

      const endDt: Date = new Date(data[data.length - 1].timestamp);
      state_obj = { 'range': { 'start': startDt, 'end': endDt } };

      this.rtoHrlyLoadDateSlider.setState(state_obj);
      const chartType = this.rtoHrlyLoadLine.getChartType();
      if (chartType === 'Table') {
        const view = new this.gLib.visualization.DataView(this.rtoHrlyLoadTable);
        view.hideColumns([4, 5]);
        this.rtoHrlyLoadDashboard.draw(view, { sortColumn: 0 });
      } else {
        this.rtoHrlyLoadDashboard.draw(this.rtoHrlyLoadTable);
      }

    }
  }

  onResized(event: ResizedEvent) {
    const width = event.newWidth;
    const height = event.newHeight;

    if (this.rtoHrlyLoadLine !== undefined) {
      this.rtoHrlyLoadLine.draw();
      this.rtoHrlyLoadDateSlider.draw();
    }
  }
  ngOnDestroy(): void {
    this.destroyed.next();
    this.destroyed.complete();
  }
  private switchChart() {

    let chartType;
    const view = new this.gLib.visualization.DataView(this.rtoHrlyLoadTable);

    // view.hideColumns([4, 5]);
    // tslint:disable-next-line:triple-equals
    if (this.btnLabel == 'Show as Chart') {
      chartType = 'ComboChart';
      this.rtoHrlyLoadLine.setChartType(chartType);
      this.btnLabel = 'Show as Table';
    } else {
      chartType = 'Table';
      this.rtoHrlyLoadLine.setChartType(chartType);
      this.btnLabel = 'Show as Chart';

    }
    const ChartType = this.rtoHrlyLoadLine.getChartType();

    const options = this.getOptions(chartType);
    this.rtoHrlyLoadLine.setOptions(options);
    this.rtoHrlyLoadLine.setOption('title', this.chartTitle);
    if (chartType === 'Table') {
      this.rtoHrlyLoadDashboard.draw(view, { sortColumn: 0 });
    } else {
      this.rtoHrlyLoadDashboard.draw(this.rtoHrlyLoadTable);
    }
  }

}

